export const kioskDevicesResource = {
  name: 'Kiosks',
  fields: {
    id: 'ID',
    siteId: 'Premises',
    siteName: 'Premises',
    name: 'Name',
    status: 'Status',
    apiKeySuffix: 'API Key',
    nearbyChargerIds: 'Nearby Chargers',
    octopusDeviceId: 'Octopus Device ID',
    lastHeartbeatAt: 'Last Heartbeat',
    health: 'Health',
    appVersion: 'App Version',
    launcherVersion: 'Launcher Version',
    updateState: 'Update State',
    updateStateAt: 'Update State Since',
    updateError: 'Update Error',
    settlementDueSince: 'Settlement Due Since',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    maintenanceEnabled: 'Maintenance mode',
  },
  status: { pending: 'Pending enrollment', active: 'Active', disabled: 'Disabled' },
  maintenance: {
    chip: 'Maintenance',
    switchLabel: 'Maintenance mode',
    helperText: 'Locks this kiosk on the maintenance screen until switched off. Charging in progress continues.',
    enabled: 'Maintenance mode switched on',
    disabled: 'Maintenance mode switched off',
  },
  health: {
    reader: 'Octopus reader', terminal: 'Card terminal', printer: 'Printer', paper: 'Paper', clock: 'Clock',
    ok: 'OK', absent: 'Not configured', error: 'Error', low: 'Low', out: 'Out', unknown: 'Unknown',
    skewMs: 'Clock skew %{ms} ms', offline: 'Offline', online: 'Online', neverSeen: 'Never connected',
  },
  sections: { basicInfo: 'Basic Information', hardware: 'Hardware', status: 'Status', settings: 'Settings', enrollment: 'Enrollment' },
  list: { subtitle: 'Self-service charging kiosks and their health' },
  create: {
    title: 'Register Kiosk',
    subtitle: 'Create a kiosk record and get its one-time enrollment code',
    siteHelperText: 'Only premises with kiosk access enabled are listed',
    nameHelperText: 'Shown in the admin console and on receipts, e.g. "Lobby kiosk"',
    nearbyChargersHelperText: 'Chargers closest to this kiosk, listed first on the screen',
    octopusDeviceIdHelperText: 'Optional. The reader device ID appears here after enrollment if left blank',
  },
  edit: {
    title: 'Kiosk',
    issueCode: 'Issue new enrollment code',
    issueCodeConfirm: 'This revokes the kiosk\'s current credentials. The kiosk must be re-enrolled with the new code. Continue?',
    codeIssued: 'Enrollment code issued',
    disable: 'Disable kiosk',
    enable: 'Enable kiosk',
  },
  enrollment: {
    title: 'Enrollment code',
    body: 'Enter this code on the kiosk. It is shown only once and expires in 24 hours.',
    expires: 'Expires %{when}',
    copy: 'Copy code',
    copied: 'Code copied',
    done: 'Done',
  },
  settings: {
    title: 'Settings',
    key: 'Setting',
    value: 'Value',
    source: 'Source',
    authority: 'Authority',
    scope: { default: 'Default', system: 'System', site: 'Premises', kiosk: 'This kiosk' },
    authorityClass: { cloud: 'Console', device: 'Device' },
    override: 'Override for this kiosk',
    clear: 'Clear kiosk override',
    saved: 'Setting saved',
    cleared: 'Override cleared',
    invalid: 'Invalid value',
    jsonHint: 'Enter the value as JSON (numbers, true/false, "text", [lists] or {objects})',
    kioskScopeNotAllowed: 'Set by support',
  },
  errors: {
    KIOSK_SITE_NOT_ENABLED: 'Enable kiosk access on the premises first',
    KIOSK_NOT_FOUND: 'Kiosk not found',
    KIOSK_SETTING_INVALID_VALUE: 'The value is not valid for this setting',
    KIOSK_SETTING_SCOPE_NOT_ALLOWED: 'This setting cannot be set at this level',
  },
};
export const kioskDevices = kioskDevicesResource;
